export const FILE_UPLOAD_MAX_SIZE = 100_000_000_000;